import { render } from "./spinner.vue?vue&type=template&id=21c1006a&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=21c1006a&scoped=true&lang=css"

import exportComponent from "/builds/media-store-net/wp-immo-manager-3-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c1006a"]])

export default __exports__